import { render, staticRenderFns } from "./work-orders.html?vue&type=template&id=13da01dc&scoped=true&"
import script from "./work-orders.js?vue&type=script&lang=js&"
export * from "./work-orders.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da01dc",
  null
  
)

export default component.exports